/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {hasRole} from "../../../utils/my-puratos/roleUtils";
import connect from "react-redux/es/connect/connect";

export const withRole = WrappedComponent => (
    class extends Component {
        render() {
            const {roles, eCommerceRequired} = this.props;
            return (
                <WithRole roles={roles} eCommerceRequired={eCommerceRequired}>
                    <WrappedComponent {...this.props} />
                </WithRole>
            )
        }
    }
);

class _WithRole extends React.Component {

    render() {
        const {children, roles, eCommerceRequired, eCommerceEnabled} = this.props;

        return (
            hasRole(roles) && (!eCommerceRequired || (eCommerceRequired && eCommerceEnabled)) ?
            <React.Fragment>
                {children}
            </React.Fragment> : null
        )
    }
}

_WithRole.propTypes = {
    roles: PropTypes.array,
};

_WithRole.defaultProps = {
    eCommerceRequired: false,
};

const mapStateToProps = (state) => ({
    eCommerceEnabled: state.myPuratos_dashboard.mapping.ecommerceEnabled,
});

export const WithRole = connect(mapStateToProps)(_WithRole);


